import { DEVELOPMENT_ENVIRONMENT_BASE_URL } from './development-environment-base-url';
import { IConfig } from './i-config';

export class Config {
  constructor(private baseConfig: IConfig) {}

  private get baseUrl(): string {
    return `${window.location.protocol}//${window.location.hostname}`;
  }

  private get portWithSeparator(): string {
    const { port } = window.location;
    if (['443', '80', ''].includes(port)) return '';

    return `:${port}`;
  }

  get oAuthRedirectUri() {
    return this.baseConfig.oauthRedirectUri;
  }

  get oAuthIssuerUri() {
    return this.baseConfig.oauthIssuerUri;
  }

  get oAuthClientId() {
    return this.baseConfig.oauthClientId;
  }

  get apiBaseUrl(): string {
    if (this.baseConfig.nodeEnv === 'local') {
      return DEVELOPMENT_ENVIRONMENT_BASE_URL;
    }

    return this.baseConfig.apiBaseurl;
  }

  get analyticsKey(): string {
    return this.baseConfig.gaKey;
  }

  get collectionMaxSize(): number {
    return this.baseConfig.collectionsMaxassetcount;
  }

  get logoutUrl(): string {
    return `${this.baseConfig.logoutUrl}${this.baseUrl}${this.portWithSeparator}`;
  }

  get nodeEnv(): string {
    return this.baseConfig.nodeEnv;
  }

  get tagManagerKey(): string {
    return this.baseConfig.gtmKey;
  }

  get applicationInsightsInstrumentationKey() {
    return this.baseConfig.instrumentationKey;
  }

  get applicationInsightsDebug() {
    return this.baseConfig.enableDebug === 'TRUE';
  }
}
